/*
 * @Author: 朱占伟
 * @LastEditors: 李青花
 * @description:支付相关
 * @Date: 2021-09-07 16:25:42
 * @LastEditTime: 2022-04-22 16:16:32
 */

import { post, } from 'utils/request';
import $api from "src/config/api.config"

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 获取支付方式
 * @param {*}
 * @return {*}
 */
export const getPayType = async (params = null) => {
  try {
    const res = await post($api.POST_PAYTYPE, params);
    return res;
  } catch (error) {
    console.error('getPayType:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 获取支付说明信息
 * @param {*}
 * @return {*}
 */
export const getPayInfo = async (params = null) => {
  try {
    const res = await post($api.POST_PAYRYPE_INFO, params);
    return res;
  } catch (error) {
    console.error('getPayInfo:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 获取支付端id
 * @param {*}
 * @return {*}
 */
export const getClientId = async (params = null) => {
  try {
    const res = await post($api.POST_PAYTYPE_ID, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('getClientId:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 获取支付订单状态
 * @param {*}
 * @return {*}
 */
export const getPayOrderStatus = async (params = null) => {
  try {
    const res = await post($api.POST_PAYTYPE_ORDER_STATUS, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('getPayOrderStatus:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 获取支付订单状态
 * @param {*}
 * @return {*}
 */
export const getBalance = async (params = null) => {
  try {
    const res = await post($api.POST_PAYTYPE_ORDER_GETBALANCE, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: 创建待制度订单
 * @param {*}
 * @return {*}
 */
export const createOrder = async (params = null) => {
  try {
    const res = await post($api.CREATE_PAY_ORDER, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('createOrder:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: Paypal 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByPayPal = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_PAYPAL, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPayPal:', error)
    return Promise.resolve(null);
  }
};


/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: Pacypay 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByPacypayDirect = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_PACYPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPacypayDirect:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: wanpay 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByWanPay = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_WANPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByWanPay:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: Stripe 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByStripeAgent = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_STRIPEPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByStripeAgent:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: PassPay 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByPassPay = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_PASSPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPassPay:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: GoAllPay 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByAllPay = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_ALLPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByAllPay:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-07 16:30:27
 * @LastEditTime:
 * @description: Glocash 支付
 * @param {*}
 * @return {*}
 */
export const payOrderByGloCash = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_GLOCASHPAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByGloCash:', error)
    return Promise.resolve(null);
  }
};

/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: 统一的payssion支付
     * @param {*}
     * @return {*}
     */

export const payOrderByPayssion = async (orderId, pmId, isInsufficient=false) => {
  try {
    const res = await post($api.PAY_ORDER_UNIQUEPAY, {
      orderId,
      pmId,
      isInsufficient
    });
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayssion:', error)
    return Promise.resolve(null);
  }
}

/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: Payop-Bitcoin支付
     * @param {*}
     * @return {*}
     */
export const payOrderByPayopBitcoin = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_PAYOP_BITCOIN,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayopBitcoin:', error)
    return Promise.resolve(null);
  }
}
/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: Payop-Bitcoin Cash支付
     * @param {*}
     * @return {*}
     */
export const payOrderByPayopBitcoinCash = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_PAYOP_BITCOINCASH,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayopBitcoinCash:', error)
    return Promise.resolve(null);
  }
}
/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: Payop-Bitcoin Cash支付
     * @param {*}
     * @return {*}
     */
export const payOrderByPayopLitecoin = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_PAYOP_LITECOIN,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayopLitecoin:', error)
    return Promise.resolve(null);
  }
}
/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: PayOp-Ethereum支付
     * @param {*}
     * @return {*}
     */

export const payOrderByPayOpEthereum = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_PAYOP_ETHEREUM,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayOpEthereum:', error)
    return Promise.resolve(null);
  }
}
export const payOrderByPayEpayEthereum = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_EPAY_USDT,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayEpayEthereum:', error)
    return Promise.resolve(null);
  }
}
export const payOrderByBinance = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_BINANCE,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByBinance:', error)
    return Promise.resolve(null);
  }
}
export const payOrderByCoinBase = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_COIN_BASE,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByCoinBase:', error)
    return Promise.resolve(null);
  }
}
export const payOrderByPayEpayResult = async (params) => {
  try {
    const res = await post($api.PAY_ORDER_EPAY_USDTRESULT,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayEpayResult:', error)
    return Promise.resolve(null);
  }
}
/**
     * @Date: 2021-09-09 16:44:04
     * @LastEditTime:
     * @description: 创建Paypal订单
     * @param {*}
     * @return {*}
     */

export const payOrderByPayPalId = async (orderId) => {
  try {
    const res = await post($api.POST_CREATE_PAY_ORDER, {
      orderId
    });
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('payOrderByPayPalId:', error)
    return Promise.resolve(null);
  }
}
//payop支付方法
export const payOrderByPayOp = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_PAYOP, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPayOp:', error)
    return Promise.resolve(null);
  }
};

//triple_a支付方法
export const payOrderByTripleA = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_TRIPLE_A, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByTripleA:', error)
    return Promise.resolve(null);
  }
};

//xanpay支付方法
export const payOrderByXanPay = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_XAN_PAY, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('PAY_ORDER_XAN_PAY:', error)
    return Promise.resolve(null);
  }
};

//Payoneer支付方法
export const payOrderByPayoneer = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_PAYONEER, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('PAY_ORDER_PAYONEER:', error)
    return Promise.resolve(null);
  }
};

//测试支付方法
export const payOrderByPayTest = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_TEST, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPayTest:', error)
    return Promise.resolve(null);
  }
};

//Airwallex
export const payOrderByPayAirwallex = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_AIRWALLEX, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('payOrderByPayAirwallex:', error)
    return Promise.resolve(null);
  }
};

//Cryptomus支付方法
export const payOrderByCryptomus = async (params = null) => {
  try {
    const res = await post($api.PAY_ORDER_CRYPTOMUS, params);
    if (res.code === 0) {
      return res.data
    }
    return null;
  } catch (error) {
    console.error('PAY_ORDER_CRYPTOMUS:', error)
    return Promise.resolve(null);
  }
};

/**
 * @Date: 2021-09-09 16:44:04
 * @LastEditTime:
 * @description: 智能能投放
 * @param {*}
 * @return {*}
*/
export const getCompeteApps = async (params={}) => {
  try {
    const res = await post($api.GET_COMPETE_APPS,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getCompeteApps:', error)
    return Promise.resolve(null);
  }
}

/**
 * @Date: 2021-09-09 16:44:04
 * @LastEditTime:
 * @description: 根据竞品app获取竞品关键词
 * @param {*}
 * @return {*}
*/

export const getServiceSmartCtrl = async (params={}) => {
  try {
    const res = await post($api.GET_SMART_CTRL, params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getServiceSmartCtrl:', error)
    return Promise.resolve(null);
  }
}

export const getCompeteKeyword = async (params={}) => {
  try {
    const res = await post($api.GET_COMPETE_WORDS,params);
    return res.data
  } catch (error) {
    console.error('getCompeteKeyword:', error)
    return Promise.resolve(null);
  }
}
export const getSmartCompeteKeyword = async (params={}) => {
  try {
    const res = await post($api.GET_SMART_COMPETE_WORDS,params);
    return res.data
  } catch (error) {
    console.error('getSmartCompeteKeyword:', error)
    return Promise.resolve(null);
  }
}

// 获取当前用户的app
export const getUserApp = async (params={}) => {
  try {
    const res = await post($api.GET_APP_LIST,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getUserApp:', error)
    return Promise.resolve(null);
  }
}

// 使用优惠码充值
export const usePromoCode = async (params={}) => {
  try {
    const res = await post($api.POST_PROMO_CODE,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getUserApp:', error)
    return Promise.resolve(null);
  }
}

//获取推荐词
export const getRecommendKeywords = async (params={}) => {
  try {
    const res = await post($api.GET_RECOMMENDWORDS,params);
    return res.data
  } catch (error) {
    console.error('getRecommendKeywords:', error)
    return Promise.resolve(null);
  }
}

//获取上次下单内容
export const getLastContact = async (params={}) => {
  try {
    const res = await post($api.POST_LASTCONTACT,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getRecommendKeywords:', error)
    return Promise.resolve(null);
  }
}
//获取上次ACQU下单内容
export const getAcquLastContact = async (params={}) => {
  try {
    const res = await post($api.POST_ACQU_LASTCONTACT,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getRecommendKeywords:', error)
    return Promise.resolve(null);
  }
}
//获取api服务套餐
export const getApiServices = async (params={}) => {
  try {
    const res = await post($api.GET_API_SERVICES,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getApiServices:', error)
    return Promise.resolve(null);
  }
}
export const getApiServicesNumbers = async (params={}) => {
  try {
    const res = await post($api.GET_API_CALLNUMBERS,params);
    if (res.code === 0) {
      return res.data
    }
    return null
  } catch (error) {
    console.error('getApiServicesNumbers:', error)
    return Promise.resolve(null);
  }
}

